import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import toast, { LoaderIcon } from "react-hot-toast";
import { useDeleteCredentialLicenseMutation } from "repositories/user-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

function DeleteDocumentModal({ onClose, t, credentialId, refetchData }) {
  const [isDeleting, setIsDeleting] = useState(false);
  const queryClient = useQueryClient();
  const { profile } = useAccountOwnerCommon();
  const deleteMutation = useDeleteCredentialLicenseMutation();

  const onConfirm = async () => {
    if (!credentialId) {
      toast.error(t("somethingWentWrong") || "Credential ID is missing");
      return;
    }

    setIsDeleting(true);
    try {
      await deleteMutation.mutateAsync(credentialId);
      toast.success(t("accountOwner.credentialDeletedSuccessfully"));
      // Invalidate queries to refresh the list
      queryClient.invalidateQueries(["user", profile?.id]);

      if (refetchData) {
        refetchData();
      }
      // Close modal
      onClose();
    } catch (error) {
      toast.error(
        error.message || t("somethingWentWrong") || "Something went wrong",
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      isOpen={true}
      toggle={onClose}
      className="modal-dialog-centered profile-specialty-modal"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={onClose}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <Text
          size="25px"
          marginBottom="10px"
          weight="500"
          color="#111b45"
          className=" text-center"
        >
          <span className="modal-title-25">
            {" "}
            {t("accountOwner.deleteDocument")}
          </span>{" "}
        </Text>
        <div className="text-center">
          {t("accountOwner.deleteDocumentDescription")}
        </div>
        <div className="text-center">
          {t("accountOwner.deleteDocumentConfirmation")}
        </div>
        <div className="d-md-flex flex-row btn-box justify-content-center">
          <button
            className={
              "button button-round button-shadow mr-md-4 mb-3 w-sm-100" +
              (isDeleting ? " d-flex gap-xs align-items-center" : "")
            }
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting && <LoaderIcon />}
            {t("delete")}
          </button>

          <button
            className="button mb-md-3 button-round button-border button-dark btn-mobile-link"
            onClick={onClose}
            disabled={isDeleting}
          >
            {t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(DeleteDocumentModal);
